import { JIRA_PROJECT_TYPE_SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';

export const isCompanyManagedSoftwareProject = (
	projectStyle: string | null | undefined,
	projectType: string | null | undefined,
): boolean =>
	projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === JIRA_PROJECT_TYPE_SOFTWARE_PROJECT;
